import { render, staticRenderFns } from "./PrintRGReportModal.vue?vue&type=template&id=d0b66d56&"
import script from "./PrintRGReportModal.vue?vue&type=script&lang=js&"
export * from "./PrintRGReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports